import { createContext, useContext } from "react";

export type ThemeMode = "light" | "dark";

export interface ThemeModeContextInterface {
  mode: ThemeMode;
  toggleMode: (origin?: { x: number; y: number }) => void;
}

// Only an explicit toggle is stored; bumped from "wizardworkz-theme", which saved every visit's mode
export const THEME_MODE_STORAGE_KEY = "wizardworkz-theme-v2";

export const getInitialThemeMode = (): ThemeMode => {
  try {
    const stored = localStorage.getItem(THEME_MODE_STORAGE_KEY);
    if (stored === "light" || stored === "dark") {
      return stored;
    }
  } catch (e) {
    // storage unavailable, fall back to the default beige theme
  }
  return "light";
};

export const ThemeModeContext = createContext<ThemeModeContextInterface>({
  mode: "light",
  toggleMode: () => {},
});

export const useThemeMode = () => useContext(ThemeModeContext);
